import dynamic from 'next/dynamic';

export default dynamic(() => import('./StaticDateRangePickerInternal'), { ssr: false });
